import {Component, Input, NgZone} from '@angular/core';
import { PaymentService } from '../../services/payment.service';
import { ActivatedRoute } from '@angular/router';
import {PaymentComponent} from '../../payment.component';
import {Modal} from 'ngx-modialog/plugins/bootstrap';
import {Observable} from 'rxjs/Observable';
import {TranslateService} from '@ngx-translate/core';
import {CommonHttpService} from '../../../shared/services/http.service';
import {Response} from '@angular/http';

@Component({
    selector: 'payment-resume-pay-button',
    templateUrl: './payment.resume.pay-button.component.html',
    styleUrls: ['../../payment.component.scss']
})
export class PaymentResumePayButtonComponent {
    @Input('requiresContractsAcceptance') requiresContractsAcceptance = true;
    @Input('paymentMethod') paymentMethod;
    @Input('amount') amount;
    public loading = false;
    public captchaEnabled = false;
    public contractsValidated = false;
    public contracts = [];
    public activityDataData;
    public config3ds: Array<Object> = [];
    public zipcode = '';
    private bpmpiAlreadyInitialized = false;

    constructor(
        protected activatedRoute: ActivatedRoute,
        private paymentService: PaymentService,
        private zone: NgZone,
        protected modal: Modal,
        protected translate: TranslateService,
        protected http: CommonHttpService
    ) {
        this.activityDataData = this.activatedRoute.snapshot.data;
        const data = this.activatedRoute.snapshot.data;
        this.handleReCaptchaConfigurations(data);
        this.handleCartItemsContracts(data);
        this.paymentService.contractsAccepted$.subscribe(() => {
            this.contractsValidated = true;
        });
        this.paymentService.contractsPending$.subscribe(() => {
            this.contractsValidated = false;
        });
        this.paymentService.refused$.subscribe((error: string) => {
            this.zone.run(() => {
                this.loading = false;
            });
        });
    }

    /**
     * Get reCAPTCHA configurations from store configurations to
     * enable/disable and configure key.
     **/
    private handleReCaptchaConfigurations(data) {
        const definedStoreConfigurations = data['storeConfigurations'] !== undefined
            && data['storeConfigurations'] !== null;
        if (!definedStoreConfigurations) {
            return;
        }

        const storeConfigurations = data['storeConfigurations'];
        this.captchaEnabled = storeConfigurations['checkout-captcha-enabled'] === '1';
    }
    /**
     * Get required contracts for each cart item.
     **/
    private handleCartItemsContracts(data) {
        const items = data.cartRestore || [];
        items.forEach((item) => {
            let contractIds = new Set(this.contracts.map(contract => contract.id));
            let itemContracts = item.contracts || [];

            this.contracts = [...this.contracts, ...itemContracts.filter(c => !contractIds.has(c.id))]
        });

        this.paymentService.setRequiresAcceptanceContracts(this.contracts);
        if (this.contracts.length === 0) {
            this.contractsValidated = true;
        }
    }

    /**
     * Make the payment
     **/
    public async pay(captchaToken = null) {
        if (null !== captchaToken) {
            this.paymentService.setReCaptchaToken(captchaToken);
        }
        if (this.isBspag3dsEnabled()) {
            this.loading = true;
            this.payBspag3ds();
            return;
        }

        if (this.isCielo()) {
            this.loading = true;
            await this.cieloCyberSource();
            if (this.isCielo3dsEnabled()) {
                this.payCielo3ds();
                return;
            }
        }

        if (this.isPagarMe3dsEnabled()) {
            this.loading = true;
            await this.payPagarMe3ds();
            return;
        }

        this.paymentService.pay();
    }
    /**
     * Mark contract as signed locally and globally.
     **/
    public contractSigned(contract) {
        this.paymentService.pushSignedContract(contract);
    }
    /**
     * Mark contract as refused locally and globally.
     **/
    public contractRefused(contract) {
        this.paymentService.pullRefusedContract(contract);
    }


    /****************
     * Bspag 3ds, depois colocar em outro lugar organizado
     ****************/
    public loadSafe2PayScript() {
          return new Promise((resolve, reject) => {
            if ((window as any).Safe2Pay) {
                resolve();
                return;
            }

            const script = document.createElement('script');
            script.src = 'https://static.safe2pay.dev/scripts/verify_3DS2.min.js';
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Erro ao carregar 3dsBspag.'));
            document.body.appendChild(script);
              console.log('loadSafe2PayScript called');
        });
    }

    public isBspag3dsEnabled() {
        return this.paymentMethod.allow_3ds && this.paymentMethod.payment_gateway_tenant_name === 'Bspag';
    }

    public resetSafe2PayMpi() {
        const existingScript = document.querySelector('script[src="https://static.safe2pay.dev/scripts/verify_3DS2.min.js"]');
        if (existingScript) {
            existingScript.remove();
        }
        if ((window as any).Safe2Pay) {
            (window as any).Safe2Pay = undefined;
        }

    }

    public payBspag3ds() {
        this.resetSafe2PayMpi();
        const Config = {
            IsEnabled: true,
            IsSandbox: this.paymentMethod.sandbox_3ds,
            IsDebug: this.paymentMethod.sandbox_3ds,
            IsChallengeSuppressed: this.paymentMethod.suppressed_3ds_challenge,
        };

        this.loadSafe2PayScript().then(() => {
            console.log('Safe2Pay script loaded successfully.');
            const interval = setInterval(() => {
                const Safe2Pay = (window as any).Safe2Pay;
                console.log('Safe2Pay object:', Safe2Pay);
                if (Safe2Pay && Safe2Pay.Mpi && typeof Safe2Pay.Mpi.Init === 'function') {
                    clearInterval(interval);
                    this.registerSafe2PayEvents();
                    Safe2Pay.Mpi.Init(Config, this.amount);
                    Safe2Pay.Mpi.addEventListener('onReady', (e: any) => {
                        const formData = this.paymentService.formatData();
                        const s2pObject = {
                            currency: 'BRL',
                            installments: formData.installments,
                            cardnumber: formData.card.number,
                            cardexpirationmonth: formData.card.expiration_month,
                            cardexpirationyear: formData.card.expiration_year,
                            cardalias: formData.card.holder_name,
                            billto_street1: formData.deliveries.billing_address.address,
                            billto_street2: formData.deliveries.billing_address.number + ' ' +
                                (formData.deliveries.billing_address.complement || ''),
                            billto_city: formData.deliveries.billing_address.city,
                            billto_state: formData.deliveries.billing_address.state,
                            billto_zipcode: formData.deliveries.billing_address.zip_code,
                            billto_zibillto_countrypcode: 'BR',
                        };
                        Safe2Pay.Mpi.Checkout(s2pObject);
                    });
                }
            }, 100);
        }).catch(error => {
            console.error('Erro ao carregar Safe2Pay:', error);
        });
    }

    private registerSafe2PayEvents() {
        const Safe2Pay = (window as any).Safe2Pay;
        const self = this;
        Safe2Pay.Mpi.addEventListener('onSuccess', (e: any) => {
            this.paymentService.set3ds(
                {
                    'cavv': e.Cavv,
                    'xid': e.Xid,
                    'eci': e.Eci,
                    'version3ds': e.Version,
                    'referenceId': e.ReferenceId
                }
            );
            this.paymentService.pay();
        });

        Safe2Pay.Mpi.addEventListener('onFailure', (e: any) => {
            const xid = e.Xid;
            const eci = e.Eci;
            const version = e.Version;
            const referenceId = e.ReferenceId;

            console.warn('Falha na autenticação:', { xid, eci, version, referenceId });
            // Decida se deseja prosseguir com a autorização mesmo após a falha na autenticação
            self.show3dsErrorModal('3DS_ERRORS.FAILURE');
            self.zone.run(() => {
                self.loading = false;
            });
            return;
        });

        Safe2Pay.Mpi.addEventListener('onUnenrolled', (e: any) => {
            const eci = e.Eci; // Código indicador do e-commerce, que representa o resultado da autenticação
            console.warn('Cartão não elegível para autenticação 3DS:', { eci });
            // Oriente o comprador a verificar com o emissor se o cartão está habilitado para autenticação no e-commerce
            self.show3dsErrorModal('3DS_ERRORS.UNSUPPORTED_CARD');
            self.zone.run(() => {
                self.loading = false;
            });
            return;
        });
    }

    /****************
     * CIELO 3ds, depois colocar em outro lugar organizado
     ****************/

    public isCielo3dsEnabled() {
        return this.paymentMethod.allow_3ds && this.isCielo();
    }

    public isCielo() {
        return this.paymentMethod.payment_gateway_tenant_name === 'Cielo';
    }

    public setValue( name, selector, value) {
        let element = document.querySelector(selector + name) as HTMLInputElement;
        if (!element) {
            element = document.createElement('input');
            element.type = 'hidden';
            element.className = name;
            document.body.appendChild(element);
        }
        element.value = value;
    }

    public addClassCielo3ds() {
        document.querySelector('.card-expiration-month').classList.add('bpmpi_cardexpirationmonth');
        document.querySelector('.card-expiration-year').classList.add('bpmpi_cardexpirationyear');
        document.querySelector('.card-installments').classList.add('bpmpi_installments');

        const formData = this.paymentService.formatData();
        this.setValue('bpmpi_billto_street1', '.', formData.deliveries.billing_address.address);
        if (formData.deliveries.billing_address.complement === '') {
            this.setValue('bpmpi_billto_street2', '.', formData.deliveries.billing_address.number);
        } else {
            this.setValue('bpmpi_billto_street2', '.',
                formData.deliveries.billing_address.number + ' ' + formData.deliveries.billing_address.complement);
        }
        this.setValue('bpmpi_cardnumber', '.', formData.card.number);
        this.setValue('bpmpi_billto_city', '.', formData.deliveries.billing_address.city);
        this.setValue('bpmpi_billto_state', '.', formData.deliveries.billing_address.state);
        this.zipcode = formData.deliveries.billing_address.zip_code;
        this.setValue('bpmpi_billto_zipcode', '.', this.zipcode);
        this.setValue('bpmpi_totalamount', '.', Math.round(this.amount * 100));
        this.setValue('bpmpi_auth_notifyonly', '.', this.paymentMethod.suppressed_3ds_challenge);

        if (this.paymentMethod.sandbox_3ds) {
            this.setValue('bpmpi_merchant_url', '.', 'https://store1.test');
        } else {
            this.setValue('bpmpi_merchant_url', '.', window.location.origin);
        }
    }

    public async cieloCyberSource() {
        if (this.paymentMethod.antifraud_option === undefined ||
            this.paymentMethod.antifraud_option === null ||
            this.paymentMethod.antifraud_option === '') {
            return;
        }
        const fingerPrintElement = document.querySelector('.' + 'fingerprint') as HTMLInputElement;
        this.paymentService.setFingerprint(fingerPrintElement.value);

        const ip = await this.fetchIp();

        this.paymentService.setBrowser({
            'ipAddress': ip,
            'CookiesAccepted': localStorage.getItem('cookiesAccepted') === 'true'
        });
    }
    async fetchIp() {
        const response = await fetch('https://engine.api.betalabs.net/api/me-ip');
        const data: { ip: string } = await response.json();
        return data.ip;
    }


    public payCielo3ds() {
        this.loading = true;
        const self = this;
        this.addClassCielo3ds();
        this.http.useAuth().get('checkout/payment/payment-gateways/' + this.paymentMethod.id + '/zipcode/' + this.zipcode).subscribe({
            next: (config) => {
                // this.config3ds = config.json();
                console.log('Iniciando pagamento com Cielo 3DS...');
                // this.cieloGetAccessToken(this.config3ds).then((data: any) => {
                    this.setValue('bpmpi_accesstoken', '.',  config.json().access_token);
                    this.setValue('bpmpi_billto_contactname', '.',  config.json().full_name);
                    this.setValue('bpmpi_billto_email', '.',  config.json().email);
                    this.setValue('bpmpi_billto_phonenumber', '.',  config.json().telephone);

                    if ((window as any).BP && (window as any).BP.Mpi) {
                        console.warn('Cielo 3DS já foi inicializado anteriormente.');
                        (window as any).BP.Mpi.authenticate();
                        return;
                    }

                    // this.setValue('bpmpi_accesstoken', '.', data.access_token);
                    (window as any).bpmpi_config = this.bpmpi_config.bind(this);
                    this.loadCielo3dsScript().then(() => {
                        if ((window as any).BP) {
                            console.log('Script 3DS carregado, iniciando autenticação...');
                            // (window as any).BP.Mpi.init(config);
                            // (window as any).BP.Mpi.authenticate();
                            this.waitForMpiReady(() => {
                                const conf = this.bpmpi_config();
                                (window as any).BP.Mpi.init(conf);
                            });
                        } else {
                            console.error('Cielo 3ds não foi carregado corretamente.');
                            // self.show3dsErrorModal('3DS_ERRORS.LOAD_ERROR');
                            // this.loading = false;
                            return;
                        }
                    }).catch(error => {
                        // this.loading = false;
                        // self.show3dsErrorModal('3DS_ERRORS.LOAD_CATCH');
                        console.error('Erro ao carregar Cielo 3ds:', error);
                        return;
                    });
                // }).catch(error => {
                //     this.loading = false;
                //     self.show3dsErrorModal('3DS_ERRORS.LOAD_UNAUTHORIZED');
                //     console.error('Erro ao obter access_token:', error);
                //     return;
                // });
            },
            error: (err) => {
                // this.loading = false;
                self.show3dsErrorModal('3DS_ERRORS.GENERIC');
                console.error('Erro ao buscar configuração do 3ds:', err);
                return;
            }
        });
    }

    public waitForMpiReady(callback: () => void) {
        const interval = setInterval(() => {
            if ((window as any).BP && (window as any).BP.Mpi && typeof (window as any).BP.Mpi.init === 'function') {
                clearInterval(interval);
                callback();
            }
        }, 100);
    }

    public loadCielo3dsScript() {
        return new Promise((resolve, reject) => {
            if ((window as any).BP) {
                resolve();
                return;
            }
            const script = document.createElement('script');
            if (this.paymentMethod.sandbox_3ds) {
                script.src = 'https://mpisandbox.braspag.com.br/Scripts/BP.Mpi.3ds20.min.js';
            } else {
                script.src = 'https://mpi.braspag.com.br/Scripts/BP.Mpi.3ds20.min.js';
            }
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Erro ao carregar 3dsCielo.'));
            document.body.appendChild(script);
        });
    }

    public bpmpi_config() {

        // Configuração do ambiente e eventos do 3DS Cielo.
        let environment = '';
        if (this.paymentMethod.sandbox_3ds) {
            environment = 'SDB';
        } else {
            environment = 'PRD';
        }

        const debug = this.paymentMethod.sandbox_3ds;
        const self = this;

        return {
            onReady: function () {
                self.bpmpiAlreadyInitialized = true;
                // Configuração do ambiente realizada com sucesso.
                if ((window as any).BP && (window as any).BP.Mpi) {
                    (window as any).BP.Mpi.authenticate();
                }
                self.zone.run(() => {
                    self.loading = false;
                });
            },
            onSuccess: (e) =>  {
                // Cartão elegível para autenticação, e portador autenticou com sucesso.
                this.paymentService.set3ds(
                    {
                        'cavv': e.Cavv,
                        'xid': e.Xid,
                        'eci': e.Eci,
                        'version3ds': e.Version,
                        'referenceId': e.ReferenceId,
                        'dataOnly': this.paymentMethod.suppressed_3ds_challenge
                    }
                );
                this.paymentService.pay();
            },
            onFailure: (e) => {
                self.show3dsErrorModal('3DS_ERRORS.FAILURE');
                self.zone.run(() => {
                    self.loading = false;
                });
                return;
            },
            onUnenrolled: (e) =>  {
                // Cartão não elegível para autenticação (não autenticável).
                // this.paymentService.set3ds(
                //     {
                //         'cavv': '',
                //         'xid': e.Xid,
                //         'eci': e.Eci,
                //         'version3ds': e.Version,
                //         'referenceId': e.ReferenceId,
                //         'dataOnly': this.paymentMethod.suppressed_3ds_challenge
                //     }
                // );
                // this.paymentService.pay();
                self.zone.run(() => {
                    self.loading = false;
                });
                self.show3dsErrorModal('3DS_ERRORS.UNSUPPORTED_CARD');
                return;
            },
            onDisabled: (e) => {
                // Loja não requer autenticação do portador (classe "bpmpi_auth" false -> autenticação desabilitada).
                self.zone.run(() => {
                    self.loading = false;
                });
                this.paymentService.pay();
            },
            onError:  (e) => {
                // Erro no processo de autenticação.
                self.zone.run(() => {
                    self.loading = false;
                });
                self.show3dsErrorModal('3DS_ERRORS.GENERIC');
                return;
            },
            onUnsupportedBrand: (e) => {
                // Bandeira não suportada para autenticação.
                self.zone.run(() => {
                    self.loading = false;
                });
                self.show3dsErrorModal('3DS_ERRORS.UNSUPPORTED_CARD');
                return;
                // this.paymentService.pay();
            },
            Environment: environment,
            Debug: debug,
        };
    }

    /****************
     * PagarMe V5 3DS (Stone)
     ****************/

    public isPagarMe(): boolean {
        const name = this.paymentMethod.payment_gateway_tenant_name;
        return name === 'Pagar.me' || name === 'PagarMeV5';
    }

    public isPagarMe3dsEnabled(): boolean {
        return this.paymentMethod.allow_3ds && this.isPagarMe();
    }

    public loadPagarMe3dsScript(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            if ((window as any).TDS) {
                resolve();
                return;
            }
            const script = document.createElement('script');
            script.id = 'pagarme-3ds-script';
            script.src = this.paymentMethod.sandbox_3ds
                ? 'https://3ds-nx-js.stone.com.br/test/v2/3ds2.min.js'
                : 'https://3ds-nx-js.stone.com.br/live/v2/3ds2.min.js';
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Erro ao carregar 3DS PagarMe.'));
            document.body.appendChild(script);
        });
    }

    private ensurePagarMe3dsContainers(): void {
        if (!document.getElementById('tdsMethodContainer')) {
            const el = document.createElement('div');
            el.id = 'tdsMethodContainer';
            el.style.cssText = 'display:none;';
            document.body.appendChild(el);
        }
        if (!document.getElementById('challengeContainer')) {
            const overlay = document.createElement('div');
            overlay.id = 'pagarme3dsChallengeOverlay';
            overlay.style.cssText = [
                'position:fixed;top:0;left:0;width:100%;height:100%;',
                'z-index:9999;background:rgba(0,0,0,0.75);',
                'display:flex;align-items:center;justify-content:center;',
            ].join('');

            const modal = document.createElement('div');
            modal.style.cssText = [
                'position:relative;background:#fff;',
                'border-radius:8px;overflow:hidden;',
                'width:420px;max-width:95vw;',
                'box-shadow:0 12px 40px rgba(0,0,0,0.4);',
            ].join('');

            const closeBtn = document.createElement('button');
            closeBtn.type = 'button';
            closeBtn.innerHTML = '&times;';
            closeBtn.setAttribute('aria-label', 'Cancelar autenticação');
            closeBtn.style.cssText = [
                'position:absolute;top:8px;right:12px;',
                'background:none;border:none;',
                'font-size:26px;line-height:1;cursor:pointer;',
                'color:#555;z-index:10001;padding:2px 6px;',
            ].join('');
            closeBtn.onclick = () => {
                const overlayEl = document.getElementById('pagarme3dsChallengeOverlay');
                if (overlayEl) { overlayEl.remove(); }
                const tdsScript = document.getElementById('pagarme-3ds-script');
                if (tdsScript) { tdsScript.remove(); }
                if ((window as any).TDS) { delete (window as any).TDS; }
                this.show3dsErrorModal('3DS_ERRORS.CANCELLED');
                this.zone.run(() => { this.loading = false; });
            };

            const challengeEl = document.createElement('div');
            challengeEl.id = 'challengeContainer';
            challengeEl.style.cssText = 'width:100%;';

            const loader = document.createElement('div');
            loader.id = 'pagarme3dsChallengeLoader';
            loader.style.cssText = [
                'display:flex;align-items:center;justify-content:center;',
                'min-height:400px;',
            ].join('');
            const spinner = document.createElement('div');
            spinner.style.cssText = [
                'width:40px;height:40px;border-radius:50%;',
                'border:4px solid #e0e0e0;border-top-color:#555;',
                'animation:pagarme3dsSpin 0.8s linear infinite;',
            ].join('');
            loader.appendChild(spinner);
            challengeEl.appendChild(loader);

            if (!document.getElementById('pagarme3dsSpinStyle')) {
                const style = document.createElement('style');
                style.id = 'pagarme3dsSpinStyle';
                style.textContent = '@keyframes pagarme3dsSpin{to{transform:rotate(360deg)}}';
                document.head.appendChild(style);
            }

            modal.appendChild(closeBtn);
            modal.appendChild(challengeEl);
            overlay.appendChild(modal);
            document.body.appendChild(overlay);


            const observer = new MutationObserver(() => {
                const loaderEl = document.getElementById('pagarme3dsChallengeLoader');
                if (loaderEl) { loaderEl.style.display = 'none'; }
                observer.disconnect();
            });
            observer.observe(challengeEl, { childList: true });
        }
    }

    public async payPagarMe3ds(): Promise<void> {
        try {
            const formData = this.paymentService.formatData();
            const billingAddress = formData.deliveries.billing_address;

            const response = await this.http.useAuth()
                .get('checkout/payment/payment-gateways/' + this.paymentMethod.id + '/3ds-token?zipcode=' + billingAddress.zip_code)
                .toPromise();

            const { token, email } = response.json();

            await this.loadPagarMe3dsScript();
            this.ensurePagarMe3dsContainers();
            const amountCents = Math.round(this.amount * 100);

            const shippingAddr = formData.deliveries.delivery_address || billingAddress;
            const buildAddressBlock = (addr: any) => ({
                country: 'BR',
                state: (addr.state || '').toUpperCase(),
                city: addr.city,
                zip_code: (addr.zip_code || '').replace(/\D/g, ''),
                line_1: `${addr.number}, ${addr.address}, ${addr.neighborhood}`,
                line_2: addr.complement || addr.number,
            });

            const orderData: any = {
                customer: { email },
                shipping: {
                    recipient_name: formData.card.holder_name,
                    address: buildAddressBlock(shippingAddr),
                },
                payments: [{
                    payment_method: 'credit_card',
                    credit_card: {
                        card: {
                            number: formData.card.number.replace(/\s/g, ''),
                            holder_name: formData.card.holder_name,
                            exp_month: Number((formData.card as any).expiration_month),
                            exp_year: Number((formData.card as any).expiration_year),
                            billing_address: buildAddressBlock(billingAddress),
                        },
                    },
                    amount: amountCents,
                }],
            };

            orderData.requestor_url = window.location.origin;

            console.log('[PagarMe 3DS] orderData:', JSON.stringify(orderData, null, 2));

            console.log('[PagarMe 3DS] orderData:', JSON.stringify(orderData, null, 2));

            const TDS = (window as any).TDS;
            const results: Array<{
                tds_server_trans_id: string;
                trans_status: string;
                challenge_canceled: boolean;
            }> = await TDS.init({
                token,
                tds_method_container_element: document.getElementById('tdsMethodContainer'),
                challenge_container_element: document.getElementById('challengeContainer'),
                challenge_window_size: '05',
                use_default_challenge_iframe_style: true,
            }, orderData);

            if (!results || results.length === 0) {
                this.show3dsErrorModal('3DS_ERRORS.GENERIC');
                this.zone.run(() => { this.loading = false; });
                return;
            }

            const result = results[0];

            if (result.challenge_canceled) {
                this.show3dsErrorModal('3DS_ERRORS.CANCELLED');
                this.zone.run(() => { this.loading = false; });
                return;
            }

            // N = falha na autenticação, R = recusado pelo emissor
            if (result.trans_status === 'N' || result.trans_status === 'R') {
                this.show3dsErrorModal('3DS_ERRORS.FAILURE');
                this.zone.run(() => { this.loading = false; });
                return;
            }

            this.paymentService.setPagarMe3ds({
                transaction_id: result.tds_server_trans_id,
                trans_status: result.trans_status,
            });
            this.paymentService.pay();

        } catch (error) {
            console.error('Erro no fluxo 3DS PagarMe:', error);
            this.show3dsErrorModal('3DS_ERRORS.GENERIC');
            this.zone.run(() => { this.loading = false; });
        }
    }

    private show3dsErrorModal(messageKey: string = '3DS_ERRORS.GENERIC') {
        this.translate.get(['3DS_ERRORS.TITLE', messageKey]).subscribe((translations) => {
            this.modal.alert()
                .size('sm')
                .title(translations['3DS_ERRORS.TITLE'])
                .body(translations[messageKey])
                .okBtn('Fechar')
                .open();
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/payment/resume/pay-button/payment.resume.pay-button.component.ts